<template>
    <a class="nav-link" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
        <svg :class="{'svg-filled': wishListCount}" xmlns="http://www.w3.org/2000/svg" width="24.485" height="21.599" viewBox="0 0 24.485 21.599"><g id="Icon" transform="translate(0.95 0.95)"><path id="Path" d="M22.134,4.24a5.943,5.943,0,0,0-8.407,0L12.583,5.385,11.438,4.24a5.944,5.944,0,0,0-8.407,8.405l1.146,1.145L12.583,22.2l8.405-8.407,1.146-1.145A5.942,5.942,0,0,0,22.134,4.24Z" transform="translate(-1.29 -2.499)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.9"/></g></svg>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
